import React from 'react';

import './Panel.scss';

function Panel({ children }: React.PropsWithChildren<unknown>) {
  return <div className="Panel">{children}</div>;
}

export default Panel;
